<template>
  <div>
    <!-- Content -->


    <!-- -------------  -->
    <!-- Shopping Cart  -->
    <!-- -------------  -->
    <div v-if="view == 'shoppingCart'" style="margin-bottom:-10px;">
      <h3>Shopping Cart</h3>
      <div style="height:10px;"></div>

      <span v-show="digs.length > 0">
        <shopping-cart
        v-for="dig in digs" 
        v-bind:key="dig.order_id" 
        v-bind:item_id="dig.item_id"
        v-bind:item_name="dig.item_name"
        v-bind:item_amount="dig.item_amount"
        v-bind:item_price="dig.item_price"
        v-bind:item_size="dig.item_size"
        v-bind:coin_id="dig.coin_id"
        v-bind:item_config="dig.item_config"
        @card-delete="cardDelete" 
        @card-update="cardUpdate"
        @digsRefresh="digsRefresh"
        />

        <br>
        
        {{ prodLabel }} price: ${{ productsPrice }}
        <br>
        International shipping: ${{ shipping }}
        <br>
        <br>
        <b>Final sum: $US {{ (finalSum) }}</b>
        <br>
        <span v-if="finalSum > 500" style="font-size:13px;color:red;">
          The maximum amount of a single order is 500 USD. Please remove some of the items.
          <br>
          To order more items, you can make multiple orders, each up to 500 USD.
          <br>
        </span>
        <span v-if="finalSum < 50" style="font-size:13px;color:red;">
          The minimum single order value is 50 USD. To proceed further, please add some extra items.
          <br>
        </span>

        <span v-if="shippingObject.shippingCountry == 'AU' || shippingObject.shippingCountry == 'NZ'" style="font-size:14px;color:red;">
          <div style="height:5px;"></div>
          20% tax has been applied to your order because of the GST (goods and service tax), and a higher labor cost for orders going to Australia and New Zealand.
          <!-- <b>Attention!</b> GST (goods and service tax) has been applied. For all goods sold by foreign online retailers to Australian (10% GST) and starting January 1, 2020, New Zealand (15% GST) consumers.
          <br>
          <span style="color:grey;">GST base $47.00, applied by Printful Inc., ARN 300014240078</span> -->
        </span>


        <span v-if="shippingObject.shippingCountry == 'FR' || shippingObject.shippingCountry == 'LT'  || shippingObject.shippingCountry == 'AT'  || shippingObject.shippingCountry == 'BE'  || shippingObject.shippingCountry == 'BG'  || shippingObject.shippingCountry == 'HR'  || shippingObject.shippingCountry == 'CY'  || shippingObject.shippingCountry == 'CZ'  || shippingObject.shippingCountry == 'DK'  || shippingObject.shippingCountry == 'IE'  || shippingObject.shippingCountry == 'EE'  || shippingObject.shippingCountry == 'FI'  || shippingObject.shippingCountry == 'DE'  || shippingObject.shippingCountry == 'GR'  || shippingObject.shippingCountry == 'HU'  || shippingObject.shippingCountry == 'IT'  || shippingObject.shippingCountry == 'LV'  || shippingObject.shippingCountry == 'LU'  || shippingObject.shippingCountry == 'MT'  || shippingObject.shippingCountry == 'NL'  || shippingObject.shippingCountry == 'PL'  || shippingObject.shippingCountry == 'PT'  || shippingObject.shippingCountry == 'RO'  || shippingObject.shippingCountry == 'SK'  || shippingObject.shippingCountry == 'SI'  || shippingObject.shippingCountry == 'ES' || shippingObject.shippingCountry == 'SE'" style="font-size:14px;color:red;">
          <div style="height:5px;"></div>
          21% VAT charge applied for EU countries.
        </span>

        <span v-if="shippingObject.shippingCountry == 'GB'" style="font-size:14px;color:red;">
          <div style="height:5px;"></div>
          20% VAT charge applied for United Kingdom.
        </span>

        <span v-if="shippingObject.shippingCountry == 'CA'" style="font-size:14px;color:red;">
          <div style="height:5px;"></div>
          20% tax has been applied to your order because of the Canadian sales tax, and a higher labor cost for orders going to Canada.
          <!-- 10% sales tax applied for Canada. -->
        </span>

        <span v-if="shippingObject.shippingCountry == 'SG' || shippingObject.shippingCountry == 'JP' || shippingObject.shippingCountry == 'HK' || shippingObject.shippingCountry == 'TW' || shippingObject.shippingCountry == 'TH'" style="font-size:14px;color:red;">
          <div style="height:5px;"></div>
          20% tax has been applied to your order because of a higher labor cost for orders going to Hong Kong, Singapore, Taiwan, Thailand, and Japan.
        </span>

        <br>

    <span v-if="finalSum > 50 && finalSum < 500">
        <!--           -->
        <!-- CHECKOUT  -->
        <!--           -->
          <h3>Checkout</h3>
          <div style="height:10px;"></div>

          <div class="payment-inner payment-inner-address" style="float:left;">

            <div style="text-align:center;box-sizing:border-box;">

              <div class="div-shipping" >
                <div style="display:inline;float:left;">Shipping details and contacts</div>
              </div>

              <div style="padding:10px;padding-top:24px;padding-bottom:20px;background-color:#E9E9E9;">
              <input type="text" class="input-basic" v-model="shippingObject.shippingNameSurname" placeholder="First and last name">
              <br>
              <input type="text" class="input-basic" v-model="shippingObject.shippingAddressLine1" placeholder="Street and address nr.">
              <br>
              <input type="text" class="input-basic" v-model="shippingObject.shippingAddressLine2" placeholder="City, State">
              <br>
              <input type="text" class="input-basic" v-model="shippingObject.shippingZipCode" placeholder="Zip / Postal code">
              <br>
              <select v-model="shippingObject.shippingCountry" id="select-countries" class="select-countries">
                <option disabled selected value>Country</option>
                <option value="US">United States ( USA )</option><option value="GB">United Kingdom ( UK )</option><option value="CA">Canada</option><option value="AU">Australia</option><option value="AF">Afghanistan</option><option value="AL">Albania</option><option value="DZ">Algeria</option><option value="AD">Andorra</option><option value="AO">Angola</option><option value="AI">Anguilla</option><option value="AQ">Antarctica</option><option value="AG">Antigua and Barbuda</option><option value="AR">Argentina</option><option value="AM">Armenia</option><option value="AW">Aruba</option><option value="AT">Austria</option><option value="AZ">Azerbaijan</option><option value="BS">Bahamas</option><option value="BH">Bahrain</option><option value="BD">Bangladesh</option><option value="BB">Barbados</option><option value="BY">Belarus</option><option value="BE">Belgium</option><option value="BZ">Belize</option><option value="BJ">Benin</option><option value="BM">Bermuda</option><option value="BT">Bhutan</option><option value="BO">Bolivia</option><option value="BA">Bosnia and Herzegovina</option><option value="BW">Botswana</option><option value="BV">Bouvet Island</option><option value="BR">Brazil</option><option value="IO">British Indian Ocean Territory</option><option value="BN">Brunei Darussalam</option><option value="BG">Bulgaria</option><option value="BF">Burkina Faso</option><option value="BI">Burundi</option><option value="KH">Cambodia</option><option value="CM">Cameroon</option><option value="CV">Cape Verde</option><option value="KY">Cayman Islands</option><option value="CF">Central African Republic</option><option value="TD">Chad</option><option value="CL">Chile</option><option value="CN">China</option><option value="CX">Christmas Island</option><option value="CC">Cocos (Keeling) Islands</option><option value="CO">Colombia</option><option value="KM">Comoros</option><option value="CG">Congo</option><option value="CD">Congo, the Democratic Republic of the</option><option value="CK">Cook Islands</option><option value="CR">Costa Rica</option><option value="CI">Cote D'Ivoire</option><option value="HR">Croatia</option><option value="CW">Curacao</option><option value="CY">Cyprus</option><option value="CZ">Czech Republic</option><option value="DK">Denmark</option><option value="DJ">Djibouti</option><option value="DM">Dominica</option><option value="DO">Dominican Republic</option><option value="EC">Ecuador</option><option value="EG">Egypt</option><option value="SV">El Salvador</option><option value="GQ">Equatorial Guinea</option><option value="ER">Eritrea</option><option value="EE">Estonia</option><option value="ET">Ethiopia</option><option value="FK">Falkland Islands (Malvinas)</option><option value="FO">Faroe Islands</option><option value="FJ">Fiji</option><option value="FI">Finland</option><option value="FR">France</option><option value="GF">French Guiana</option><option value="PF">French Polynesia</option><option value="TF">French Southern Territories</option><option value="GA">Gabon</option><option value="GM">Gambia</option><option value="GE">Georgia</option><option value="DE">Germany</option><option value="GH">Ghana</option><option value="GI">Gibraltar</option><option value="GR">Greece</option><option value="GL">Greenland</option><option value="GD">Grenada</option><option value="GP">Guadeloupe</option><option value="GT">Guatemala</option><option value="GG">Guernsey</option><option value="GN">Guinea</option><option value="GW">Guinea-Bissau</option><option value="GY">Guyana</option><option value="HT">Haiti</option><option value="HM">Heard Island and Mcdonald Islands</option><option value="HN">Honduras</option><option value="HK">Hong Kong</option><option value="HU">Hungary</option><option value="IS">Iceland</option><option value="IN">India</option><option value="ID">Indonesia</option><option value="IQ">Iraq</option><option value="IE">Ireland</option><option value="IM">Isle of Man</option><option value="IL">Israel</option><option value="IT">Italy</option><option value="JM">Jamaica</option><option value="JP">Japan</option><option value="JE">Jersey</option><option value="JO">Jordan</option><option value="KZ">Kazakhstan</option><option value="KE">Kenya</option><option value="KI">Kiribati</option><option value="KR">Korea, Republic of</option><option value="KW">Kuwait</option><option value="KG">Kyrgyzstan</option><option value="LA">Lao People's Democratic Republic</option><option value="LV">Latvia</option><option value="LB">Lebanon</option><option value="LS">Lesotho</option><option value="LR">Liberia</option><option value="LY">Libyan Arab Jamahiriya</option><option value="LI">Liechtenstein</option><option value="LT">Lithuania</option><option value="LU">Luxembourg</option><option value="MO">Macao</option><option value="MK">Macedonia, the Former Yugoslav Republic of</option><option value="MG">Madagascar</option><option value="MW">Malawi</option><option value="MY">Malaysia</option><option value="MV">Maldives</option><option value="ML">Mali</option><option value="MT">Malta</option><option value="MH">Marshall Islands</option><option value="MQ">Martinique</option><option value="MR">Mauritania</option><option value="MU">Mauritius</option><option value="YT">Mayotte</option><option value="MX">Mexico</option><option value="FM">Micronesia, Federated States of</option><option value="MD">Moldova, Republic of</option><option value="MC">Monaco</option><option value="MN">Mongolia</option><option value="ME">Montenegro</option><option value="MS">Montserrat</option><option value="MA">Morocco</option><option value="MZ">Mozambique</option><option value="MM">Myanmar</option><option value="NA">Namibia</option><option value="NR">Nauru</option><option value="NP">Nepal</option><option value="NL">Netherlands</option><option value="NC">New Caledonia</option><option value="NZ">New Zealand</option><option value="NI">Nicaragua</option><option value="NE">Niger</option><option value="NG">Nigeria</option><option value="NU">Niue</option><option value="NF">Norfolk Island</option><option value="NO">Norway</option><option value="OM">Oman</option><option value="PK">Pakistan</option><option value="PW">Palau</option><option value="PS">Palestinian Territory, Occupied</option><option value="PA">Panama</option><option value="PG">Papua New Guinea</option><option value="PY">Paraguay</option><option value="PE">Peru</option><option value="PH">Philippines</option><option value="PN">Pitcairn</option><option value="PL">Poland</option><option value="PT">Portugal</option><option value="QA">Qatar</option><option value="RE">Reunion</option><option value="RO">Romania</option><option value="RU">Russian Federation</option><option value="RW">Rwanda</option><option value="SH">Saint Helena</option><option value="KN">Saint Kitts and Nevis</option><option value="LC">Saint Lucia</option><option value="PM">Saint Pierre and Miquelon</option><option value="VC">Saint Vincent and the Grenadines</option><option value="WS">Samoa</option><option value="SM">San Marino</option><option value="ST">Sao Tome and Principe</option><option value="SA">Saudi Arabia</option><option value="SN">Senegal</option><option value="RS">Serbia</option><option value="SC">Seychelles</option><option value="SL">Sierra Leone</option><option value="SG">Singapore</option><option value="MF">Sint Maarten</option><option value="SK">Slovakia</option><option value="SI">Slovenia</option><option value="SB">Solomon Islands</option><option value="SO">Somalia</option><option value="ZA">South Africa</option><option value="GS">South Georgia and the South Sandwich Islands</option><option value="ES">Spain</option><option value="LK">Sri Lanka</option><option value="SD">Sudan</option><option value="SR">Suriname</option><option value="SJ">Svalbard and Jan Mayen</option><option value="SZ">Swaziland</option><option value="SE">Sweden</option><option value="CH">Switzerland</option><option value="TW">Taiwan</option><option value="TJ">Tajikistan</option><option value="TZ">Tanzania</option><option value="TH">Thailand</option><option value="TL">Timor-Leste</option><option value="TG">Togo</option><option value="TK">Tokelau</option><option value="TO">Tonga</option><option value="TT">Trinidad and Tobago</option><option value="TN">Tunisia</option><option value="TR">Turkey</option><option value="TM">Turkmenistan</option><option value="TC">Turks and Caicos Islands</option><option value="TV">Tuvalu</option><option value="UG">Uganda</option><option value="UA">Ukraine</option><option value="AE">United Arab Emirates</option><option value="UM">United States Minor Outlying Islands</option><option value="UY">Uruguay</option><option value="UZ">Uzbekistan</option><option value="VU">Vanuatu</option><option value="VA">Vatican City</option><option value="VE">Venezuela</option><option value="VN">Vietnam</option><option value="VG">Virgin Islands, British</option><option value="WF">Wallis and Futuna</option><option value="EH">Western Sahara</option><option value="YE">Yemen</option><option value="ZM">Zambia</option><option value="ZW">Zimbabwe</option>
              </select>
              <div style="height:25px;"></div>
              <input type="text" class="input-basic" v-model="shippingObject.shippingEmail1" placeholder="E-mail">
              <br>
              <input type="text" class="input-basic" v-model="shippingObject.shippingEmail2" placeholder="Repeat e-mail">
              <br>
              <input type="text" class="input-basic" v-model="shippingObject.shippingPhone" placeholder="Phone nr (optional)">
              <div v-html="shippingErrors" class="address-errors"></div>
            </div>
          </div>
        </div>
              


                <span class="switch-mobile">
                  <div style="font-size:14px;color:#333333;">
                    <div style="cursor:pointer;vertical-align:text-top;width:39%;display:inline-block;text-align:right;" class="switch-label-left" @click="payWithChange('card')">
                      <b v-if="payWith == 'card'" >Bank card</b>
                      <span v-else style="color:#888888;">Bank card</span>
                    </div>
                    <div style="width:22%;text-align:center;display:inline-block;">
                      <label class="switch">
                        <input type="checkbox" @change="payWithChange('switch')" v-model="isSwitched">
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div style="cursor:pointer;vertical-align:text-top;width:39%;display:inline-block;text-align:left;" @click="payWithChange('crypto')">
                      <b v-if="payWith == 'crypto'" >Crypto</b>
                      <span v-else style="color:#888888;">Crypto</span>
                    </div>
                  </div>
                </span>


            <div class="payment-inner payment-inner-card div-payment-method" >

              <div id="premium" class="payment-box">

                <section v-if="payWith == 'card'" class="creditly-wrapper gray-theme" style="margin-bottom:10px;">
                    
                  <div style="background:#6a6a6a;color:#FFF;font-size:14px;padding:10px;margin:0;height:20px;padding-top:10px;">

                    <div style="display:inline;float:left;">Pay with card</div>

                  </div>

                  <div style="clear:both;padding:15px;height:170px;text-align:center;font-size:14px;">

                    <div style="padding-top:30px;width:200px;margin:0 auto;">
                      <img src="/img/stripe-logo.png" style="margin-top:-7px;" width="100">
                    </div>

                    <div style="height:5px;"></div>
                    <div style="width:fit-content;margin:0 auto;">
                      <div style="display:inline;float:left;">
                        <b>Pay with credit or debit card</b>
                      </div>
                    </div>

                    <div style="clear:both;padding-top:20px;">
                      You will be redirected to Stripe to complete your order.
                    </div>
                  </div>

                </section>

                <section v-if="payWith == 'crypto'" class="creditly-wrapper gray-theme" style="margin-bottom:10px;max-width:300px;">
                    
                  <div style="background:#6a6a6a;color:#FFF;font-size:14px;padding:10px;margin:0;height:20px;padding-top:10px;">

                    <div style="display:inline;float:left;">Pay with cryptocurrency</div>

                  </div>

                  <div style="clear:both;padding:15px;height:170px;text-align:center;font-size:14px;">

                    <div style="padding-top:30px;width:200px;margin:0 auto;">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1477.83 202"><path d="M68.48,132.28a60.09,60.09,0,0,0,9.74,15A56.71,56.71,0,0,1,50.66,154C21.3,154,0,134.66,0,103.78,0,72.69,22.39,53.35,50.66,53.35a52.29,52.29,0,0,1,26,6.46A61,61,0,0,0,67.5,75.29a39.65,39.65,0,0,0-14.9-2.81c-17.39,0-30.87,11.09-30.87,31.31,0,19.13,13,31.31,31.75,31.31a40.53,40.53,0,0,0,15-2.81h0Zm59-78.93c28.91,0,49.78,20.44,49.78,50.43,0,29.79-20.87,50.22-49.78,50.22C98.82,154,78,133.57,78,103.78c0-30,20.87-50.43,49.56-50.43h0Zm0,18.48c-16.09,0-27.83,12.4-27.83,32,0,19.35,11.74,31.74,27.83,31.74,16.53,0,28-12.39,28-31.74C155.56,84.22,144,71.83,127.51,71.83Zm63.48,80V55.52h21.52v96.31H191ZM188.16,26a13.48,13.48,0,0,1,27,0,13.48,13.48,0,1,1-27,0h0Zm43.12,35.66a129.05,129.05,0,0,1,44.13-8.26c24.57,0,40.22,9.35,40.22,36.52v62h-21.3v-60c0-13.91-8.7-18.92-20.66-18.92a74.58,74.58,0,0,0-20.87,2.83v76.09H231.29V61.61h0ZM333.66,4h21.52V58.13c4.56-2.39,13.48-4.78,22-4.78,27.83,0,48.7,17.82,48.7,48.7,0,31.08-20.65,52-56.3,52a107.05,107.05,0,0,1-35.87-6.3V4h0Zm21.52,129.57a52.5,52.5,0,0,0,15,2c19.78,0,33.92-10.87,33.92-33,0-18.7-13.26-29.79-29.57-29.79a40.17,40.17,0,0,0-19.35,4.57v56.31h0ZM488,87.26C488,76.82,480.16,72,469.52,72c-11.09,0-19.78,3.26-27.83,7.82V61.17A64.22,64.22,0,0,1,473,53.35c21.08,0,36.08,8.7,36.08,32.82v63.7a143.31,143.31,0,0,1-33,3.92c-25,0-43.27-7.61-43.27-29.35,0-19.56,16.74-29.12,44.56-29.12H488V87.26h0Zm0,22.4h-9.13c-15,0-24.79,4.34-24.79,14.13,0,10,9.14,13.91,22.18,13.91A78.12,78.12,0,0,0,488,136.61v-27h0Zm36.73,16.09c8.92,6.74,19.56,10.87,29.34,10.87,9.57,0,15.87-3.26,15.87-10.87,0-7.83-5.65-10.65-18-13.91-20-4.56-28.48-12.61-28.48-29.35,0-19.57,14.79-29.13,34.35-29.13,10.87,0,19.56,2.39,27.61,7.39V80.52c-8.47-6.08-16.74-9.78-27-9.78-9.35,0-14.35,4.56-14.35,10.87s4.12,9.57,15.21,12.61c22,4.78,31.53,13,31.53,30.44,0,20.21-15.43,29.34-36.3,29.34-11.31,0-22.61-3-29.78-7.82V125.74h0Zm95.54-17.17V109c1.31,17.17,16.09,26.52,31.08,26.52,13.26,0,22.83-3,32.39-9.35v18.92c-8.7,6.08-21.52,8.91-33.91,8.91-30,0-50.43-19.13-50.43-49.56,0-30.65,20-51.09,46.52-51.09,28,0,41.3,18,41.3,44.34v10.88h-67ZM667,94.66c-0.43-15-7.82-23.26-21.74-23.26-12.39,0-21.52,8.7-24.35,23.26H667Z" style="fill:#0667d0"/><path d="M767.5,0h0A3.5,3.5,0,0,1,771,3.5v195a3.5,3.5,0,0,1-3.5,3.5h0a3.5,3.5,0,0,1-3.5-3.5V3.5A3.5,3.5,0,0,1,767.5,0Z" style="fill:#aab4c0"/><path d="M924.3,61.29A51.08,51.08,0,0,0,897.73,54C870,54,848,74.09,848,103.73c0,29.48,20.57,49.73,49.73,49.73a53.89,53.89,0,0,0,27.05-7.13v-11.5c-7,6.48-17,9.56-27.22,9.56-21.71,0-39.37-15.88-39.37-40.66s17.66-40.66,39.37-40.66c10.21,0,19.76,3.24,26.73,9.88V61.29Zm7.59,55.24c0-21.87,14.42-36.94,35.48-36.94s35.48,15.07,35.48,36.94-14.42,36.94-35.48,36.94-35.48-15.07-35.48-36.94h0Zm61.07,0C993,99.36,982.27,88,967.37,88s-25.6,11.34-25.6,28.51S952.46,145,967.37,145,993,133.7,993,116.53Zm110.94,35.32h9.72V104.22c0-17.66-9.23-24.62-26.24-24.62-8.59,0-17.66,2.27-26.08,5.51-4.37-3.73-10.69-5.51-19-5.51-9.4,0-19.12,2.43-28.35,6.16v66.1h9.72V91.58a53.54,53.54,0,0,1,18.63-3.24c8.1,0,16.69,3.08,16.69,16.2v47.3h9.72V104.06a30,30,0,0,0-2.11-11.66c4.21-1.94,12.31-4.05,20.74-4.05,7.61,0,16.52,3.08,16.52,16.2v47.3h0Zm115.32,0h9.72V104.22c0-17.66-9.23-24.62-26.24-24.62-8.59,0-17.66,2.27-26.08,5.51-4.37-3.73-10.69-5.51-19-5.51-9.4,0-19.12,2.43-28.35,6.16v66.1H1139V91.58a53.55,53.55,0,0,1,18.63-3.24c8.1,0,16.69,3.08,16.69,16.2v47.3h9.72V104.06A30,30,0,0,0,1182,92.39c4.21-1.94,12.31-4.05,20.74-4.05,7.61,0,16.52,3.08,16.52,16.2v47.3h0ZM1302.46,117H1249v0.32c0,17.33,12.47,27.54,26.24,27.54,10,0,17-2.59,24.14-7.94v9.72c-6.32,4.7-15.39,6.8-24.14,6.8-20.41,0-36-13.93-36-36.94,0-21.22,14.58-36.94,33.53-36.94,17.82,0,29.65,10.69,29.65,30.78V117h0Zm-52.81-8.1h43.09c-0.65-14.74-8.59-20.74-20.41-20.74-11,0-19.93,7.45-22.68,20.74h0Zm73.36-16v59h-9.72V87.7a49.32,49.32,0,0,1,26.24-7.61,50.25,50.25,0,0,1,11.83,1.46V91.1a40.58,40.58,0,0,0-12.47-1.78c-7,0-12.15,1.46-15.88,3.56h0Zm85-7.94V95.15a35.28,35.28,0,0,0-19.76-6.64c-14.58,0-27.22,9.72-27.22,28.19,0,17.82,12.47,27.86,27.86,27.86,7.45,0,13.77-2.43,20.25-6.64v10.21a45.32,45.32,0,0,1-21.22,5.35c-19.76,0-36.77-13.77-36.77-36.94,0-23.65,17.5-36.94,36.61-36.94A39,39,0,0,1,1408,84.94h0Zm69.8,32.08h-53.46v0.32c0,17.33,12.47,27.54,26.24,27.54,10,0,17-2.59,24.14-7.94v9.72c-6.32,4.7-15.39,6.8-24.14,6.8-20.41,0-36-13.93-36-36.94,0-21.22,14.58-36.94,33.53-36.94,17.82,0,29.65,10.69,29.65,30.78V117h0Zm-52.81-8.1h43.09c-0.65-14.74-8.59-20.74-20.41-20.74-11,0-19.93,7.45-22.68,20.74h0Z" style="fill:#202a36"/></svg>
                    </div>

                    <div style="height:5px;"></div>
                    <div style="width:fit-content;margin:0 auto;">
                      <div style="display:inline;float:left;">
                        Pay with: <b>BTC</b>, <b>ETH</b>, <b>BCH</b>, <b>LTC</b>, <b>USDC</b>
                      </div>
                    </div>

                    <div style="clear:both;padding-top:25px;">
                      You will be redirected to Coinbase to complete your order.
                    </div>
                  </div>

                </section>


                <span class="switch-desktop">
                  <div style="height:5px;"></div>
                  <div style="font-size:14px;color:#333333;">
                    <div style="cursor:pointer;vertical-align:text-top;width:39%;display:inline-block;text-align:right;" class="switch-label-left" @click="payWithChange('card')">
                      <b v-if="payWith == 'card'" >Bank card</b>
                      <span v-else style="color:#888888;">Bank card</span>
                    </div>
                    <div style="width:22%;text-align:center;display:inline-block;">
                      <label class="switch">
                        <input type="checkbox" @change="payWithChange('switch')" v-model="isSwitched">
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div style="cursor:pointer;vertical-align:text-top;width:39%;display:inline-block;text-align:left;" @click="payWithChange('crypto')">
                      <b v-if="payWith == 'crypto'" >Crypto</b>
                      <span v-else style="color:#888888;">Crypto</span>
                    </div>
                  </div>
                </span>

            </div>

          </div>

        <div style="clear:both;height:25px;"></div>

        <div style="clear:both;font-size:12px;vertical-align:middle;">
          <svg xmlns="http://www.w3.org/2000/svg" style="width:8px;" viewBox="0 0 384 512"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M336,192H320V128a128,128,0,0,0-256,0v64H48A48.06,48.06,0,0,0,0,240V464a48.06,48.06,0,0,0,48,48H336a48.06,48.06,0,0,0,48-48V240a48.06,48.06,0,0,0-48-48ZM106.67,128a85.33,85.33,0,1,1,170.66,0v64H106.67V128Z" style="fill-rule:evenodd;fill:#555;"/></g></g></svg>&nbsp;Your connection is protected with <a href="https://www.ssllabs.com/ssltest/analyze.html?d=cryptoclothing.cc" target="_blank" class="underline">SSL certificate</a>
          <div style="height:5px;"></div>
          <svg xmlns="http://www.w3.org/2000/svg" style="width:8px;" viewBox="0 0 501.87 601.24"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M489.46,71.5,255.94.75a17.08,17.08,0,0,0-10,0L12.44,71.5A17.59,17.59,0,0,0,0,88.39V347.81c0,33.73,13.52,68.28,40.2,102.64C60.58,476.7,88.75,503.07,124,528.84c59.16,43.23,117.41,69.77,119.85,70.86a17.28,17.28,0,0,0,14.26,0c2.43-1.09,60.69-27.63,119.85-70.86,35.2-25.77,63.38-52.14,83.76-78.39,26.67-34.36,40.19-68.91,40.19-102.64V88.39A17.59,17.59,0,0,0,489.46,71.5Z" style="fill-rule:evenodd;fill:#555;"/></g></g></svg>&nbsp;Payments are securely processed by <a v-if="payWith == 'crypto'" href="https://commerce.coinbase.com" target="_blank" class="underline">Coinbase</a><a v-else href="https://stripe.com" target="_blank" class="underline">Stripe</a>
        </div>

        <!-- <div style="clear:both;height:25px;"></div> -->

        <div style="clear:both;height:15px;"></div>


        <!-- <p><b>Be prepared for delays:</b> Our fulfillment times will be longer than usual due to the ongoing COVID-19 situation. The entire industry is grappling with challenges and we're seeing delays in our supply chain, including distributors and shipping carriers.</p> -->

        <span v-if="shippingObject.shippingCountry == 'AU' || shippingObject.shippingCountry == 'NZ'" >
          <div style="height:10px;"></div>
          <span style="font-size:14px;color:red;">
            20% tax applied for Australia and New Zealand.
            <!-- <b>Attention!</b> GST (goods and service tax) has been applied. For all goods sold by foreign online retailers to Australian (10% GST) and starting January 1, 2020, New Zealand (15% GST) consumers.
            <br>
            <span style="color:grey;">GST base $47.00, applied by Printful Inc., ARN 300014240078</span> -->
          </span>
          <div style="height:10px;"></div>
          <b>Final sum: $US {{ (finalSum) }}</b>
        </span>

        <span v-if="shippingObject.shippingCountry == 'FR' || shippingObject.shippingCountry == 'LT'  || shippingObject.shippingCountry == 'AT'  || shippingObject.shippingCountry == 'BE'  || shippingObject.shippingCountry == 'BG'  || shippingObject.shippingCountry == 'HR'  || shippingObject.shippingCountry == 'CY'  || shippingObject.shippingCountry == 'CZ'  || shippingObject.shippingCountry == 'DK'  || shippingObject.shippingCountry == 'IE'  || shippingObject.shippingCountry == 'EE'  || shippingObject.shippingCountry == 'FI'  || shippingObject.shippingCountry == 'DE'  || shippingObject.shippingCountry == 'GR'  || shippingObject.shippingCountry == 'HU'  || shippingObject.shippingCountry == 'IT'  || shippingObject.shippingCountry == 'LV'  || shippingObject.shippingCountry == 'LU'  || shippingObject.shippingCountry == 'MT'  || shippingObject.shippingCountry == 'NL'  || shippingObject.shippingCountry == 'PL'  || shippingObject.shippingCountry == 'PT'  || shippingObject.shippingCountry == 'RO'  || shippingObject.shippingCountry == 'SK'  || shippingObject.shippingCountry == 'SI'  || shippingObject.shippingCountry == 'ES' || shippingObject.shippingCountry == 'SE'">
          <div style="height:10px;"></div>
          <span style="font-size:14px;color:red;">
            21% VAT charge applied for EU countries.
          </span>
          <div style="height:10px;"></div>
          <b>Final sum: $US {{ (finalSum) }}</b>
        </span>

        <span v-if="shippingObject.shippingCountry == 'GB'">
          <div style="height:10px;"></div>
          <span style="font-size:14px;color:red;">
            20% VAT charge applied for United Kingdom.
          </span>
          <div style="height:10px;"></div>
          <b>Final sum: $US {{ (finalSum) }}</b>
        </span>

        <span v-if="shippingObject.shippingCountry == 'CA'">
          <div style="height:10px;"></div>
          <span style="font-size:14px;color:red;">
            20% tax applied for Canada.
          </span>
          <div style="height:10px;"></div>
          <b>Final sum: $US {{ (finalSum) }}</b>
        </span>

        <span v-if="shippingObject.shippingCountry == 'SG' || shippingObject.shippingCountry == 'JP' || shippingObject.shippingCountry == 'HK' || shippingObject.shippingCountry == 'TW' || shippingObject.shippingCountry == 'TH'">
          <div style="height:10px;"></div>
          <span style="font-size:14px;color:red;">
            20% tax has been applied to your order because of a higher labor cost for orders going to Hong Kong, Singapore, Taiwan, and Japan.
          </span>
          <div style="height:10px;"></div>
          <b>Final sum: $US {{ (finalSum) }}</b>
        </span>

        <div style="clear:both;height:30px;"></div>

        <div class="checkbox-div" style="margin-left:0 auto;padding-top:0px!important;">
          <label>
            <input type="checkbox" name="agree" id="agree">
            <div class="checkmark"></div>
            <div style="padding-left:23px;font-size:14px;">I have read and agree with the <a :href="'/'+'terms-and-conditions'" target="_blank" class="underline">Terms and Conditions</a></div>
          </label>
        </div>

        <div v-if="termsError" style="color:red;font-size:13px;font-family:'Arial','Helvetica',sans-serif;">
            <div style="height:3px;"></div>
            Please read and accept the terms and conditions.
        </div>

        <div style="clear:both;height:25px;"></div>

        <!-- <button @click="stripeBuy()" class="button-payment">Pay $USD {{ finalSum }}.00</button> -->

        <button v-if="paymentProcessing" disabled class="button-payment-disabled">Please wait...</button>
        <button v-else @click="orderItems()" class="button-payment">Checkout</button>
        <!-- <button v-else disabled style="background-color:#999;cursor:auto;" class="button-payment">Checkout</button> -->
        <!-- <button v-else @click="orderItems()" class="button-payment">Order items for ${{ finalSum }}.00</button> -->

      </span>
      </span>

      <span v-show="digs.length < 1">
        Your shopping cart is empty
        <br>
        <br>
      </span>


    </div>
    

    <!-- --------------  -->
    <!-- Clothing/Logos  -->
    <!-- --------------  -->
    <div v-if="view == 'cryptoClothing' || view == 'cryptoLogos'" style="text-align:center;">

      <div style="height:5px;"></div>

      <div style="font-size:19px;padding-top:10px;font-weight:700;line-height:160%;">Cryptocurrency Merchandise Store</div>

      <div style="height:20px;"></div>

      <!-- <div style="font-size:18px;font-weight:500;">
        For Founders and Fans
      </div>

      <div style="height:7px;"></div> -->

      <div style="font-size:15px;">
        Discover timeless designs for most popular cryptocurrencies, including Bitcoin, Ethereum, XRP, Dogecoin, Litecoin, Monero, and many more.
      </div>

      <div class="spacer-home"></div>

      <!-- <div style="clear:both;height:40px;"></div> -->

      <!-- <div class="search-div">
        <input class="search-input" type="text" v-model="search" placeholder="Search...">
      </div> -->

      <div style="clear:both;height:60px;"></div>

      <div class="flex-grid">
        <div v-for="(coin_name, coin_id) in filteredItems" :key="coin_id" class="col">
          <div style="text-align:center;margin:0 auto;z-index:99999;margin-top:10px;">
            <router-link :to="'/'+coin_name">
              <div class="div-middle-outer"><div class="div-middle-inner"><img :src="'/thumbs/'+coin_name+'.png'+version" class="div-middle-img" :alt="logos[coin_name].name + ' (' + logos[coin_name].symbol + ') logo thumb'"></div></div><div class="div-middle-text">{{ logos[coin_name].name }} ({{ logos[coin_name].symbol }}) clothing</div>
              <!-- <div class="div-middle-outer"><div class="div-middle-inner"><img :src="'/logos/'+coin_name+'-'+logos[coin_name].symbol.toLowerCase()+'-logo.svg'" class="div-middle-img" :alt="logos[coin_name].name + ' (' + logos[coin_name].symbol + ') clothing'"></div></div><div class="div-middle-text">{{ logos[coin_name].name }} ({{ logos[coin_name].symbol }}) clothing</div> -->
            </router-link>
          </div>
        </div>
        <div class="col col-empty"></div>
        <div class="col col-empty"></div>
        <div class="col col-empty"></div>
        <div class="col col-empty"></div>
        <div class="col col-empty"></div>
      </div>
      <div style="clear:both;"></div>
      <div style="height:20px;"></div>

    </div>



    <div style="height:60px;"></div>
    <div style="text-align: center;" v-if="$route.name != 'ShoppingCart'">
      <h2>Updates</h2>
      <p>Join our mailing list to be informed about new products and other important news</p>
      <div style="height:10px;"></div>
      <span id="submit-component">
      <input type="text" id="submit-input" placeholder="Enter your e-mail">
      <span class="focus-border">
      </span>
      <div style="height:15px;"></div>
      <button id="subs-button" @click="subscribeButton()">Subscribe</button>
      </span>
      <div id="feedback"></div>
    </div>

    <div style="height:30px;"></div>

    <!-- <span v-if="$route.name != 'ShoppingCart'">
      <div style="height:60px;"></div>

      <a href="https://multiavatar.com/nft" target="_blank">
        <div class="ma-banner gradient-border">
          <img src="img/multiavatar-nft-banner.png" style="width:90%;max-width:400px;">
        </div>
      </a>
    </span> -->

  </div>
</template>

<script>
import ShoppingCart from '../components/ShoppingCart.vue';

export default {
  components: {
    ShoppingCart
  },
  data: function () {
    return {
      version: '',
      search: '',
      homePath: homePath,
      view: '',
      coins: {},
      digs: [],
      termsError: false,

      shippingObject: {
        shippingNameSurname: '',
        shippingAddressLine1: '',
        shippingAddressLine2: '',
        shippingZipCode: '',
        shippingCountry: '',
        shippingEmail1: '',
        shippingEmail2: '',
        shippingPhone: ''
      },

      shippingErrors: '',
      products: null,
      paymentProcessing: false,
      // inner: '',
      complement: '',
      payWith: 'card',
      isSwitched: false,
      gst: 0,

      // checkoutEnv: 'dev',
      // checkoutUrl: 'http://localhost/checkout/_cc/server.php',
      // stripeKey: 'pk_test_wUP3L67y5Hg9OhRlOMYElT7j00qRoJX4CC',

      // checkoutEnv: 'test',
      // checkoutUrl: 'https://cc.namemaker.app/checkout/_cc/server.php',
      // stripeKey: 'pk_test_wUP3L67y5Hg9OhRlOMYElT7j00qRoJX4CC',

      checkoutEnv: 'live',
      checkoutUrl: 'https://cryptoclothing.cc/checkout/_cc/server.php',
      stripeKey: 'pk_live_BaFplEER3YirNvKeziWVz5Ms005Fiyne7c',
    }
  },

  computed: {
    prodLabel() {
      if (this.digs.length > 1) { return "Products" }
      else { return "Product" }
    },
    productsPrice() {
      let price = 0;
      this.digs.forEach(function(element) {
        price += element.item_price * element.item_amount;
      });
      return price;
    },
    shipping() {
      // return this.digs.length + 7;
      let amount = 0;
      this.digs.forEach(function(element) {
        // e.g. 1st is just 2, because 1x2, then next again, e.g. 3x2=6 for items, and then default is 6, total 8
        console.log(element.item_name)
        if (element.item_name == "Hoodie" || element.item_name == "Sweatshirt") {
          amount += +element.item_amount*4;
        }
        else if (element.item_name == "Mug") {
          amount += +element.item_amount*5;
        }
        else {
          amount += +element.item_amount*2;
        }
      });
      amount += 10;
      return amount;
    },
    finalSum() {
      if (this.shippingObject.shippingCountry == "AU") {
        return ((this.productsPrice + this.shipping) * 1.20).toFixed(2);
        // if ((this.productsPrice + this.shipping) < 47) {
        //   this.gst = 47 * 0.1;
        // }
        // else {
        //   // console.log(this.productsPrice + this.shipping);
        //   this.gst = (this.productsPrice + this.shipping) * 0.1;
        // }
        // // console.log(this.gst)
        // return ((this.productsPrice + this.shipping) + this.gst).toFixed(2);
      }
      else if (this.shippingObject.shippingCountry == "NZ") {
        return ((this.productsPrice + this.shipping) * 1.20).toFixed(2);
        // if ((this.productsPrice + this.shipping) < 47) {
        //   this.gst = 47 * 0.15;
        // }
        // else {
        //   // console.log(this.productsPrice + this.shipping);
        //   this.gst = (this.productsPrice + this.shipping) * 0.15;
        // }
        // // console.log(this.gst)
        // return ((this.productsPrice + this.shipping) + this.gst).toFixed(2);
      }

      else if (this.shippingObject.shippingCountry == "GB") {
        return ((this.productsPrice + this.shipping) * 1.20).toFixed(2);
      }

      else if (this.shippingObject.shippingCountry == "CA") {
        return ((this.productsPrice + this.shipping) * 1.20).toFixed(2);
      }

      else if (this.shippingObject.shippingCountry == "SG") {
        return ((this.productsPrice + this.shipping) * 1.20).toFixed(2);
      }

      else if (this.shippingObject.shippingCountry == "HK") {
        return ((this.productsPrice + this.shipping) * 1.20).toFixed(2);
      }

      else if (this.shippingObject.shippingCountry == "JP") {
        return ((this.productsPrice + this.shipping) * 1.20).toFixed(2);
      }

      else if (this.shippingObject.shippingCountry == "TW") {
        return ((this.productsPrice + this.shipping) * 1.20).toFixed(2);
      }

      else if (this.shippingObject.shippingCountry == "TH") {
        return ((this.productsPrice + this.shipping) * 1.20).toFixed(2);
      }

      else if (this.shippingObject.shippingCountry == 'FR' || this.shippingObject.shippingCountry == 'LT'  || this.shippingObject.shippingCountry == 'AT'  || this.shippingObject.shippingCountry == 'BE'  || this.shippingObject.shippingCountry == 'BG'  || this.shippingObject.shippingCountry == 'HR'  || this.shippingObject.shippingCountry == 'CY'  || this.shippingObject.shippingCountry == 'CZ'  || this.shippingObject.shippingCountry == 'DK'  || this.shippingObject.shippingCountry == 'IE'  || this.shippingObject.shippingCountry == 'EE'  || this.shippingObject.shippingCountry == 'FI'  || this.shippingObject.shippingCountry == 'DE'  || this.shippingObject.shippingCountry == 'GR'  || this.shippingObject.shippingCountry == 'HU'  || this.shippingObject.shippingCountry == 'IT'  || this.shippingObject.shippingCountry == 'LV'  || this.shippingObject.shippingCountry == 'LU'  || this.shippingObject.shippingCountry == 'MT'  || this.shippingObject.shippingCountry == 'NL'  || this.shippingObject.shippingCountry == 'PL'  || this.shippingObject.shippingCountry == 'PT'  || this.shippingObject.shippingCountry == 'RO'  || this.shippingObject.shippingCountry == 'SK'  || this.shippingObject.shippingCountry == 'SI'  || this.shippingObject.shippingCountry == 'ES' || this.shippingObject.shippingCountry == 'SE') {
        return ((this.productsPrice + this.shipping) * 1.21).toFixed(2);
      }

      else {
        return (this.productsPrice + this.shipping).toFixed(2);
      }
    },
    filteredItems() {
      return Object.keys(cc_coins_home)
      .filter(key => {
        return key.toLowerCase().includes(this.search.toLowerCase()) || cc_coins_home[key].symbol.toLowerCase().includes(this.search.toLowerCase());
      })
    },

  },

  methods: {

    orderItems() {
      if (this.payWith == 'card') {
        this.stripeBuy();
      }
      else {
        this.coinbaseBuy();
      }
    },

    payWithChange(to) {
      this.termsError = false;
      this.shippingErrors = "";
      
      // console.log(to);
      if (to == 'card') {
        this.payWith = 'card';
        this.isSwitched = false;
      }
      if (to == 'crypto') {
        this.payWith = 'crypto';
        this.isSwitched = true;
      }
      if (to == 'switch') {
        if (this.payWith == 'card') {
          this.payWith = 'crypto';
        }
        else {
          this.payWith = 'card';
        }
      }
    },

    errorsCheck: function() {
      if (this.checkoutEnv != 'live') {        
        this.shippingObject.shippingNameSurname = 'Baįžęklis';
        this.shippingObject.shippingAddressLine1 = 'aaa';
        this.shippingObject.shippingAddressLine2 = 'aaa';
        this.shippingObject.shippingZipCode = '26645'
        this.shippingObject.shippingCountry = 'LT';
        this.shippingObject.shippingEmail1 = 'mail@giekaton.com';
        this.shippingObject.shippingEmail2 = 'mail@giekaton.com';
        this.shippingObject.shippingPhone = '+37065648484';
      }
      if (!document.getElementById('agree').checked) {
        this.termsError = true;
        return false;
      }
      else {
        this.termsError = false;
        this.shippingErrors = "";
        
        if (this.shippingObject.shippingNameSurname.length < 1) {
          this.shippingErrors += "Missing first and last name<br>"
        }
        if (this.shippingObject.shippingAddressLine1.length < 1) {
          this.shippingErrors += "Missing address line 1<br>"
        }
        if (this.shippingObject.shippingAddressLine2.length < 1) {
          this.shippingErrors += "Missing address line 2<br>"
        }
        if (this.shippingObject.shippingZipCode.length < 2) {
          this.shippingErrors += "Missing Zip / Postal Code<br>"
        }
        if (this.shippingObject.shippingCountry.length < 1) {
          this.shippingErrors += "Missing country<br>"
        }
        if (this.shippingObject.shippingEmail1.length < 1) {
          this.shippingErrors += "Missing e-mail address<br>"
        }
        if (this.shippingObject.shippingEmail2.length < 1) {
          this.shippingErrors += "Please repeat e-mail address<br>"
        }
        else if (this.shippingObject.shippingEmail1 != this.shippingObject.shippingEmail2) {
          this.shippingErrors += "Email addresses do not match<br>"
        }

        if (this.payWith == 'crypto') {
          this.coinbaseBuyGo();
        }
        else {
          this.stripeBuyGo();
        }
      }

      
    },

    coinbaseBuy: function() {
      this.errorsCheck();
    },

    coinbaseBuyGo: function() {

      if (this.shippingErrors.length == 0) {
        this.paymentProcessing = true;
        dexie.products.toArray((products) => {
          this.products = JSON.stringify(products);
        })
        .then((e) => {
          // console.log('zzz', self.products);
          this.coinbaseBuyProceed();
        })
        // console.log(this.productsPrice, this.shipping, this.finalSum, this.shippingNameSurname, this.shippingAddressLine1, this.shippingAddressLine2, this.shippingObject.shippingCountry, this.shippingEmail1, this.shippingPhone);
      }
      else {
        this.paymentProcessing = false;
        this.shippingErrors = '<div style="height:15px;"></div><span style="color:#222222;">Errors:</span><br>' + this.shippingErrors;
      }
    },

    coinbaseBuyProceed: function() {

      let sel = document.getElementById("select-countries");
      this.shippingObject.shippingCountryFull = sel.options[sel.selectedIndex].text;

      let shippingObject = (encodeURIComponent(JSON.stringify(this.shippingObject)));

      let data = "&productsPrice=" + this.productsPrice + "&shipping=" + this.shipping + "&finalSum=" + this.finalSum + "&shippingObject=" + shippingObject + "&productsObject=" + JSON.stringify(this.products);

      axios.post(this.checkoutUrl, 'action=coinbase' + data)
      .then(response => { 
        // console.log(typeof(response));
        // console.log(response.data);
        if (response.data[0] == 'success') {
          dexie.products.clear();
          window.location = response.data[1];
        }
      })
      
    },

    stripeBuy: function() {
      this.errorsCheck();
    },

    stripeBuyGo: function() {

      if (this.shippingErrors.length == 0) {
        this.paymentProcessing = true;
        let self = this;
        dexie.products.toArray(function(products) {
          self.products = JSON.stringify(products);
        })
        .then(function (e) {
          // console.log('zzz', self.products);
          self.stripeBuyProceed();
        })
        // console.log(this.productsPrice, this.shipping, this.finalSum, this.shippingNameSurname, this.shippingAddressLine1, this.shippingAddressLine2, this.shippingObject.shippingCountry, this.shippingEmail1, this.shippingPhone);
      }
      else {
        this.paymentProcessing = false;
        this.shippingErrors = '<div style="height:15px;"></div><span style="color:#222222;">Errors:</span><br>' + this.shippingErrors;
      }

    },

    stripeBuyProceed: function() {

      let finalSumStripe = this.finalSum + '';
      finalSumStripe = finalSumStripe.replace(/\./g, "");

      let sel = document.getElementById("select-countries");
      this.shippingObject.shippingCountryFull = sel.options[sel.selectedIndex].text;

      let shippingObject = (encodeURIComponent(JSON.stringify(this.shippingObject)));

      // console.log(this.products);

      let data = "&productsPrice=" + this.productsPrice + "&shipping=" + this.shipping + "&finalSum=" + finalSumStripe + "&shippingObject=" + shippingObject + "&productsObject=" + JSON.stringify(this.products);

      // axios.post('/stripe', 'action=stripe' + data)
      axios.post(this.checkoutUrl, 'action=stripe' + data)
      .then(response => { 

        let data = response.data;
        let stripe = Stripe(this.stripeKey);

        stripe.redirectToCheckout({
            sessionId: data.id
        })
        .then(function (result) {
            console.error(result.error.message);
        });
      })

    },

    log: function () {
      console.log(this.filteredItems);
    },
    digsRefresh: function () {
      this.$emit('countRefresh');

      let self = this;
      let digsTemp = [];

      // load products from indexedDB
      dexie.products.toArray(function(products) {
        products.forEach ( product => {
          digsTemp.unshift({item_id: product.item_id, item_name: product.item_name, item_amount: product.item_amount, item_size: product.item_size, item_price: product.item_price, coin_id: product.coin_id, item_config: product.item_config });
        });
      })
      .then(function () { self.digs = digsTemp; digsTemp = []; })
      .catch(e => {console.log('digsRefresh', e)} );
    },
    cardDelete: function(id) {
      let self = this;
      function getIndex () {
        for(var i = 0; i < self.digs.length; i += 1) {
          if(self.digs[i].id == id) { return i; }
        }
      }
      let index = getIndex();
      // delete from dynamic store
      self.digs.splice(index, 1);
    },
    cardUpdate: function(el) {
      let self = this;
      let id = el.id;
      let product = el.product;

      function getIndex () {
        for(var i = 0; i < self.digs.length; i += 1) {
          if(self.digs[i].id == id) { return i; }
        }
      }
      let index = getIndex();

      this.digs[index].text = product;
    },
    toTop: function() {
      document.body.scrollTop = 0;
    },
    initialDataLoad: function () {
      let self = this;

      dexie.products.toArray(function(products) {

        // load products from indexedDB
        dexie.products.toArray(function(products) {
          products.forEach ( product => {
            self.digs.unshift({item_id: product.item_id, item_name: product.item_name, item_amount: product.item_amount, item_size: product.item_size, item_price: product.item_price, coin_id: product.coin_id, item_config: product.item_config });
          });
        })
        .catch(e => {console.log('initial', e)} );

      });
    },
    cbtDeleteAll: function() {
      if (confirm('Are you sure you want to delete all data?')) {
        dexie.products.clear();
        this.digs = [];
      }
    },

    subscribeButton: function() {
      // var homeUrl = 'http://localhost';
      var homeUrl = 'https://cryptoclothing.cc';

      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) {
          if(xhr.response) {
              var resp = xhr.response;
              if (resp == "email error") {
              document.getElementById("feedback").innerHTML = "<span style='color:red;'><br>Error: Invalid e-mail address</span><br>";
              }
              else if (resp == "limit error") {
              document.getElementById("feedback").innerHTML = "<span style='color:red;'><br>You are doing that too much. Please wait and try again.<br>";
              }
              else if (resp == "success") {
              document.getElementById("submit-component").style.display = 'none';
              document.getElementById("feedback").innerHTML = "<b style='color:#ab00aa;font-size:16px;'>Subscribed!</b>";
              }
          }
          }
          else console.log('The request failed!');
      }
      var email = document.getElementById('submit-input').value;
      xhr.open('POST', homeUrl+'/mailing-list/_cc/server.php?action=mailing_list&data='+email);
      xhr.send();
    },

  },

  watch: {     
    $route (to, from){
      if (to.name == 'Home') {
        this.view = 'cryptoClothing';
      }
      else if (to.name == 'ShoppingCart') {
        this.view = 'shoppingCart';
      }
    }
  },

  beforeMount() {
    this.logos = cc_coins_home;
    this.version = assetsVersion;
  },

  mounted() {
    
    if (this.$route.name == 'Home') {
      this.view = 'cryptoClothing'
    }
    else if (this.$route.name == 'ShoppingCart') {
      this.view = 'shoppingCart';
    }
    
    this.initialDataLoad();


    // Mailing-list
    if (this.$route.name == 'Home') {
      var submitInput = document.getElementById("submit-input");
      submitInput.addEventListener("keyup", (event) => {
        if (event.key == "Enter") {
            event.preventDefault();
            this.subscribeButton();
        }
      });
    }

  },


};
</script>

<style>
input::-webkit-input-placeholder {
    font-size: 14px;
}


.slider-block {
  display:inline;
  vertical-align:middle;
}

.slider-block-label {
  width: 60px;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 28px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background-color: #ccc; */
  background-color: #6A6A6A;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  /* background-color: #2196F3; */
}

input:focus + .slider {
  /* box-shadow: 0 0 1px #2196F3; */
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.input-basic {
  font-size:14px!important;
  height: 24px;
  margin-bottom:8px;
  box-sizing: border-box;
  width: 232px!important;
  height: 28px!important;
}

.select-countries {
  width:232px;
  height:28px;
  -webkit-appearance: none;
  -webkit-appearance: menulist-button;
  background-color: white;
  font-size:14px;
  line-height: 28px;
}

.input-basic::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size:14px;
  color: #999;
}
.input-basic::-moz-placeholder { /* Firefox 19+ */
  font-size:14px;
  color: #999;
}
.input-basic:-ms-input-placeholder { /* IE 10+ */
  font-size:14px;
  color: #999;
}
.input-basic:-moz-placeholder { /* Firefox 18- */
  font-size:14px;
  color: #999;
}


/* input[type=text] {
  font-size:13px;
} */




/* stripe checkout - Vue component
============================================ */

.payment-container {
  border: 2px solid #e0e0e0;
  padding: 15px;
  padding-top: 25px;
  padding-bottom: 35px;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
  background-color: white;
  line-height: 130%;
  float: left;
}

.payment-inner {
  max-width: 300px;
}

.payment-box {
  clear:both;
}

.switch-mobile {
  display: none;
}

@media screen and (max-width:680px) {
  .payment-inner-card {
    clear:both;
    float: left!important;
    margin-top: 20px;
  }
  .payment-box {
    margin-top:5px;
  }
  /* .switch-label-left {
    width:70px!important;
  } */
  .switch-mobile {
    clear:both;
    width: 300px;
    float: left;
    display: block;
    margin-top:30px;
    margin-bottom:-10px;
  }
  .switch-desktop {
    display: none;
  }
}

.payment-inner input, select {
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.payment-inner-address input {
  padding-left: 5px;
}

.cc-icons {
  float: left;
  margin-left: 8px;
}

.payment-inner-address {
  line-height: 30px;
}

.dotted-line {
  width: 100%;
  margin-top: 3px;
  margin-bottom: 6px;
  border-bottom: 1px dotted #000000;
}

.input-basic {
  width: 280px;
}

.address-errors {
  color: red;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.header-fades {
  height: 140px;
}

@media screen and (max-width: 640px) {
  .header-fades {
    height: 150px;
  }
}

@media screen and (max-width: 540px) {
  .header-fades {
    height: 160px;
  }
}

@media screen and (max-width: 440px) {
  .header-fades {
    height: 180px;
  }
}

.div-shipping {
  background:#6a6a6a;color:#FFF;font-size:14px;padding:10px;margin:0;height:20px;padding-top:6px;width:280px;padding-bottom:15px;
}

.div-payment-method {
  float:right;
  width:300px;
}

@media screen and (max-width: 320px) {
  .div-shipping {
    width: 270px;
  }
  .div-payment-method {
    width: 290px;
  }
}


/* Mailing-list */

#submit-input {
        border: 1px solid #777;
        border-top: none;
        border-left: none;
        border-right: none;
        width: 250px;
        height: 29px;
        padding-left: 5px;
        text-align: center;
        outline: none;
        color: #666;
    }
    #subs-button {
        background-color: #45708d;
        padding: 5px;
        width: 160px;
        color: white;
        cursor: pointer;
        height: 32px;
        border-radius: 3px;
        border: none;
        font-size: 15px;
        outline: none;
    }
    #subs-button:hover {
        background-color: #3e7eae;
    }

/* MA Banner */
    
  .ma-banner {
    text-align:center;
    background-color:#03031F;
    border-radius:10px;
    padding:0px;
    /* border: 2px solid #00fafb; */
  }
  
  .gradient-border {
  --borderWidth: 5px;
  position: relative;
  border-radius: var(--borderWidth);
}
.gradient-border:after {
  content: '';
  position: absolute;
  top: calc(-1 * var(--borderWidth));
  left: calc(-1 * var(--borderWidth));
  height: calc(100% + var(--borderWidth) * 2);
  width: calc(100% + var(--borderWidth) * 2);
  background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);
  border-radius: calc(2 * var(--borderWidth));
  z-index: -1;
  animation: animatedgradient 3s ease alternate infinite;
  background-size: 300% 300%;
}


@keyframes animatedgradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

</style>